import easydropdown from 'easydropdown';

if ($('.bys-dropdown-wrapper select.dropdown').length) {
  const edd = easydropdown.all({
    behavior: {
      maxVisibleItems: 5
    }
});
}


const handleStart = () => {
  const $startButton = $('.js-bys-start')

  $startButton.on('click', (e) => {

    $('.js-start-content').fadeOut(300, function(){
      $('.js-build-content').fadeIn(300).addClass('is-visible')
    })

    $('.js-step').addClass('is-active');
    $('.js-step-wrapper .action.btn').addClass('is-active');

    setFirstRadios()
    $('.js-step[data-type="Size"]').find('.js-form-button').trigger('click')
  })
}

const showContent = () => {
  if($('#js-bys-content-wrapper').hasClass('bys-Shelter')) {
    $('.js-start-content').fadeOut(300, function(){
      $('.js-build-content').fadeIn(300).addClass('is-visible')
    })
    $('.js-step').addClass('is-active');
  }
}
// }

// set the first radio in each step to be checked
// notice the :not() to account for the checkbox list
const setFirstRadios = () => {
  $('.js-step-wrapper .js-step').each(function(){
    const $this = $(this)
    const $input = $this.find('.optionset:not(.checkboxset) input').first()

    $input.trigger('click');
  });
}


// if they click edit, this should run
if(window.location.href.indexOf("Material") > -1) {
  if($('.build-your-structure-form').length ) {
    $('.js-start-content').fadeOut(300, function(){
      $('.js-build-content').fadeIn(300).addClass('is-visible')
    })

    $('.js-step').addClass('is-active');
    $('.js-step-wrapper .action.btn').addClass('is-active');

    $('.js-step[data-type="Size"]').find('.js-form-button').trigger('click')
  }

}

const toggleSteps = () => {
  const $step = $('.js-step')
  const $button = $('.js-form-button')
  let $activeStep = null

  const closeAllDropdowns = () => {
    $step.addClass('is-closed');
    $('.js-step-dropdown-wrapper').slideUp();
  }

  const slideDropdowns = () => {
    if($activeStep.hasClass('is-closed')) {
      closeAllDropdowns()
      $activeStep.removeClass('is-closed')
      $activeStep.find('.js-step-dropdown-wrapper').slideDown();
    } else {
      closeAllDropdowns()
      $activeStep.addClass('is-closed')
      $activeStep.find('.js-step-dropdown-wrapper').slideUp();
    }
  }

  $button.on('click', function() {
    const $this = $(this)
    $activeStep = $this.closest('.js-step')


    if($this.closest($step).hasClass('is-active')) {
      slideDropdowns()
    } else {
      $this.closest($step).addClass('is-active')
      slideDropdowns()
    }
  })
}

const props = {
  $form: $('.build-your-structure-form'),
  $toggableFields: $('.opt-field').filter(function () {
    return $(this).data('disable-for')
  }),
  formData: {}
}


const updateFormData = () => {
  const data = props.$form.serializeArray().reduce((arr, next) => {
    if (next['name'] !== 'SecurityID') {
      arr[next['name']] = next['value']
    }

        return arr
    }, {})

  props.formData = data



    const _values = Object.values(data)
    const values = _values.map(function (el) {
      return el.replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s/g, '-');
    })

    // remove empty strings
    const filteredValues = values.filter(function (el) {
      return el != "";
    });
    const filteredValues2 = filteredValues.map(function (el) {
      return `bys-${el}`
    });

    if(!$('.js-final-choices').length) {

      $('#js-bys-content-wrapper').removeClass();
    }
    $('#js-bys-content-wrapper').addClass(filteredValues2);

}


const getFinalData = () => {

  const obj = $('.js-final-choices').data('choices')

  const _finalValues = Object.values(obj)

  const finalValues = _finalValues.map(function (el) {
    return el.replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s/g, '-');
  })

  // remove empty strings
  const filteredValues = finalValues.filter(function (el) {
    return el != "";
  });
  const finalValues2 = filteredValues.map(function (el) {
    return `bys-${el}`
  });

  $('#js-bys-content-wrapper').addClass(finalValues2);
}

if($('.js-final-choices').length) {
  getFinalData()
}



// check if the page is an edit page
const checkEditPage = () => {
  if(window.location.href.indexOf("ProductType") > -1) {
    showContent()

    $('.js-step').removeClass('is-closed is-active')
    $('.js-step').addClass('is-closed is-active')
  }
}



// Fire Print on page load

if($('.bys-print').length) {
  window.onload = function() {
    window.print();
  };
}


const handleFieldsDisplay = () => {
  const formData = props.formData

  props.$toggableFields.each((_, el) => {
    const rules = $(el).data('disable-for')

    Object.keys(rules).forEach(key => {
      if (formData.hasOwnProperty(key)) {
        if (rules[key].indexOf(formData[key]) !== -1) {
          $(el).hide()
          $(el).find('input').prop('checked', false)
          $(el).find('input').prop('disabled', true)
        } else {
          $(el).show()
          $(el).find('input').prop('disabled', false)
        }
      }
    })
  })

  props.$form.data('choices', props.formData)

  const $colorBlock = $('.js-step[data-type="Color"]')
  if($("input[value='Hip']").is(':checked')) {
    $colorBlock.addClass('is-active')
    $colorBlock.slideDown()
  } else {
    $colorBlock.removeClass('is-active')
    $colorBlock.slideUp()
  }

  const ihWrapper = $("input[value='Infared Heater']").closest('li')
  const spWrapper = $("input[value='Solar Panel Light Kit']").closest('li')
  if($("input[value='Solar Panel Light Kit']").is(':checked')) {
    ihWrapper.addClass('is-disabled')
  } else {
    ihWrapper.removeClass('is-disabled')
  }

  if($("input[value='Infared Heater']").is(':checked')) {
    spWrapper.addClass('is-disabled')
  } else {
    spWrapper.removeClass('is-disabled')
  }

  // this checks to see if one of the 15foot wide body configs are selected
  // if it is we select the firs one available after the full body option
  // which will have a display none
  if($("[data-type='Body Configuration'] input[type='radio']").is(':checked')) {
      // any one is checked
  } else {
    // none is checked
      const $newInput = $('[data-type="Body Configuration"]').find('.opt-field:not([style*="display: none"])').first()

      $newInput.find('input').trigger('click');
  }
}

const bindEvents = () => {
  props.$form.on('change', '.optionset input, .checkboxset input,  .bys-dropdown-wrapper select', () => {
    updateFormData()
    handleFieldsDisplay()
  })
}

const handleQuoteForm = () => {
    document.querySelectorAll('.quote-form-trigger').forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault()
            document.querySelector('#hubspot-quote-form-wrapper').style.display = 'block';

            const formWrapper = document.querySelector('#hubspot-quote-form-wrapper');
            const headerHeight = document.querySelector('.site-header').offsetHeight;
            const formWrapperTop = formWrapper.getBoundingClientRect().top + window.scrollY - headerHeight;
            window.scrollTo({
                top: formWrapperTop,
                behavior: 'smooth'
            });
        });
    });
}

const init = () => {
  bindEvents()
  updateFormData()
  showContent()
  handleFieldsDisplay()
  handleStart()
  toggleSteps()
  checkEditPage()
  handleQuoteForm()
}

if ($('body').hasClass('pagetype-buildyourstructurepage')) {
  init()
}
